import makeStyles from '@mui/styles/makeStyles';

export default makeStyles(() => ({
    svg: {
        width: 24,
        height: 24,
        minWidth: 24
    }
}));
